var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-29.2%",
    y: "-20.8%",
    width: "158.3%",
    height: "158.3%",
    filterUnits: "objectBoundingBox",
    id: "RadioChecked_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129411765 0 0 0 0 0.498039216 0 0 0 0 0.88627451 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "RadioChecked_svg__[object_Object]b",
    cx: 8,
    cy: 8,
    r: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#2D91FB",
    strokeWidth: 0.5,
    fill: "#3B99FC",
    cx: 8,
    cy: 8,
    r: 7.75
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#RadioChecked_svg__[object_Object]a)",
    xlinkHref: "#RadioChecked_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#RadioChecked_svg__[object_Object]b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default ForwardRef;